import { render, staticRenderFns } from "./TablaRecaudacionSeccionPreciosComponent.vue?vue&type=template&id=6ca108d1"
import script from "./TablaRecaudacionSeccionPreciosComponent.vue?vue&type=script&lang=js"
export * from "./TablaRecaudacionSeccionPreciosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports